export enum VehicleTypeEnum {
    Unknown,
    Multirotor,
    Helicopter,
    Fixedwing,
    Hybrid
}